import React, {VoidFunctionComponent, Dispatch, SetStateAction} from 'react';
import {FormattedMessage} from 'react-intl';

import {Locale} from '../../../../../shared/types/locales';

import DHMLogo from '../dhm-logo/dhm-logo';
import BurgerMenu from '../burger-menu/burger-menu';
import Navigation from '../navigation/navigation';
import DarkModeToggle from '../dark-mode-toggle/dark-mode-toggle';
// import LanguageToggle from '../language-toggle/language-toggle';

import styles from './header.module.css';
import {NavLink} from 'react-router-dom';

interface Props {
  toggleDarkMode: () => void;
  onChangeLocale: Dispatch<SetStateAction<Locale>>;
}

const Header: VoidFunctionComponent<Props> = props => (
  <header className={styles.header}>
    <div>
      <a className={styles.logo} href={window.location.href}>
        <DHMLogo />
      </a>
      <h1 className={styles.title}>
        <FormattedMessage id="title" />
      </h1>
    </div>

    <BurgerMenu>
      <NavLink
        to="/citizen-science"
        className={styles.navigationLink}
        activeClassName={styles.navigationLinkActive}>
        <FormattedMessage id="navigation.citizenScience" />
      </NavLink>
      <Navigation />
      <div className={styles.toggles}>
        <DarkModeToggle toggleDarkMode={props.toggleDarkMode} />
        {/*
            Uncomment when English translations are ready
            <LanguageToggle onChangeLocale={props.onChangeLocale} />
          */}
      </div>
    </BurgerMenu>
  </header>
);

export default Header;
